import type { Language } from 'app/lib/language';

const provinces = {
  CA: [
    { name: { en: 'Alberta', fr: 'Alberta', es: 'Alberta' }, code: 'AB' },
    { name: { en: 'British Columbia', fr: 'Colombie-Britannique', es: 'Columbia Británica' }, code: 'BC' },
    { name: { en: 'Manitoba', fr: 'Manitoba', es: 'Manitoba' }, code: 'MB' },
    { name: { en: 'New Brunswick', fr: 'Nouveau-Brunswick', es: 'Nuevo Brunswick' }, code: 'NB' },
    {
      name: { en: 'Newfoundland and Labrador', fr: 'Terre-Neuve-et-Labrador', es: 'Terranova y Labrador' },
      code: 'NL',
    },
    {
      name: { en: 'Northwest Territories', fr: 'Territoires du Nord-Ouest', es: 'Territorios del Noroeste' },
      code: 'NT',
    },
    { name: { en: 'Nova Scotia', fr: 'Nouvelle-Écosse', es: 'Nueva Escocia' }, code: 'NS' },
    { name: { en: 'Nunavut', fr: 'Nunavut', es: 'Nunavut' }, code: 'NU' },
    { name: { en: 'Ontario', fr: 'Ontario', es: 'Ontario' }, code: 'ON' },
    { name: { en: 'Prince Edward Island', fr: 'Île-du-Prince-Édouard', es: 'Isla del Príncipe Eduardo' }, code: 'PE' },
    { name: { en: 'Quebec', fr: 'Québec', es: 'Quebec' }, code: 'QC' },
    { name: { en: 'Saskatchewan', fr: 'Saskatchewan', es: 'Saskatchewan' }, code: 'SK' },
    { name: { en: 'Yukon Territory', fr: 'Yukon', es: 'Yukón' }, code: 'YT' },
  ],
};

const getCountryProvincesByLanguage = (country: string | null | undefined, language: Language) => {
  if (!country) {
    return [];
  }
  const availableCountries = Object.keys(provinces);
  if (!availableCountries.includes(country)) {
    return [];
  }
  return provinces[country as keyof typeof provinces]
    .map((province) => {
      return {
        name: province.name[language],
        code: province.code,
      };
    })
    .sort((a, b) => a.name.localeCompare(b.name));
};

export { getCountryProvincesByLanguage };
